// Le saga de résolution de conflit n'est plus utilisé (résolution automatique dans
// les sagas patient et contact). Fichier conservé au cas où on réintroduit un dialog.
export default function* watchConflictResolve() {}
